var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221.335,
    height: 159.084,
    viewBox: "0 0 221.335 159.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card",
    transform: "translate(0 -72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    transform: "translate(0 72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M204.043,72H17.292A17.312,17.312,0,0,0,0,89.292v124.5a17.312,17.312,0,0,0,17.292,17.292H204.043a17.312,17.312,0,0,0,17.292-17.292V89.292A17.312,17.312,0,0,0,204.043,72Z",
    transform: "translate(0 -72)",
    fill: "#5d647f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(27.667 99.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M112.417,177.5h-41.5A6.916,6.916,0,0,1,64,170.584V142.917A6.916,6.916,0,0,1,70.917,136h41.5a6.916,6.916,0,0,1,6.917,6.917v27.667A6.916,6.916,0,0,1,112.417,177.5Z",
    transform: "translate(-64 -136)",
    fill: "#ffd100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(27.667 168.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M88.209,313.292H70.917A6.916,6.916,0,0,1,64,306.375v-3.458A6.916,6.916,0,0,1,70.917,296H88.209a6.916,6.916,0,0,1,6.917,6.917v3.458A6.916,6.916,0,0,1,88.209,313.292Z",
    transform: "translate(-64 -296)",
    fill: "#b8bac0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(44.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M192.208,313.292H174.917A6.916,6.916,0,0,1,168,306.375v-3.458A6.916,6.916,0,0,1,174.917,296h17.292a6.916,6.916,0,0,1,6.917,6.917v3.458A6.916,6.916,0,0,1,192.208,313.292Z",
    transform: "translate(-168 -296)",
    fill: "#b8bac0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(89.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M296.208,313.292H278.917A6.916,6.916,0,0,1,272,306.375v-3.458A6.916,6.916,0,0,1,278.917,296h17.292a6.916,6.916,0,0,1,6.917,6.917v3.458A6.916,6.916,0,0,1,296.208,313.292Z",
    transform: "translate(-272 -296)",
    fill: "#b8bac0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290",
    transform: "translate(134.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M400.208,313.292H382.917A6.916,6.916,0,0,1,376,306.375v-3.458A6.916,6.916,0,0,1,382.917,296h17.292a6.916,6.916,0,0,1,6.917,6.917v3.458A6.916,6.916,0,0,1,400.208,313.292Z",
    transform: "translate(-376 -296)",
    fill: "#b8bac0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(27.667 199.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M136.626,374.917H67.458a3.458,3.458,0,1,1,0-6.917h69.167a3.458,3.458,0,1,1,0,6.917Z",
    transform: "translate(-64 -368)",
    fill: "#8a8895"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295",
    transform: "translate(110.667 199.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M290.584,374.917H259.458a3.458,3.458,0,0,1,0-6.917h31.125a3.458,3.458,0,1,1,0,6.917Z",
    transform: "translate(-256 -368)",
    fill: "#8a8895"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(41.5 99.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M137.5,160.208H102.917v-6.917H137.5v-6.917H102.917V136H96v41.5h6.917V167.125H137.5Z",
    transform: "translate(-96 -136)",
    fill: "#ff9500"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(152.168 99.667)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 21,
    cy: 20.5,
    rx: 21,
    ry: 20.5,
    transform: "translate(-0.168 0.333)",
    fill: "#ff4f19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.60595db612aa9f0c2b2aa380c832f56e.svg";
export { ForwardRef as ReactComponent };